import React from "react";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaUsers,
  FaChartLine,
  FaFileInvoiceDollar,
  FaUserShield,
  FaMobileAlt,
  FaLock,
  FaBell,
  FaEnvelope,
  FaPhoneAlt,
  FaWhatsapp,
  FaArrowRight,
  FaClock,
  FaRocket,
  FaCheckCircle,
} from "react-icons/fa";
import portalHeroImage from "../Assets/images/innerbranding.png";
import "./Portal.css";

const Portal = () => {
  /* ===== FEATURES OF THE UPCOMING PORTAL ===== */
  const portalFeatures = [
    {
      icon: <FaBuilding />,
      title: "Corporate Dashboard",
      desc: "Manage your company's staff subscriptions from one central hub.",
    },
    {
      icon: <FaUsers />,
      title: "Employee Management",
      desc: "Add, remove, and assign routes to your employees in seconds.",
    },
    {
      icon: <FaChartLine />,
      title: "Usage Analytics",
      desc: "Track attendance, occupancy, and commute patterns in real time.",
    },
    {
      icon: <FaFileInvoiceDollar />,
      title: "Bulk Invoicing",
      desc: "Generate monthly invoices and manage corporate payments easily.",
    },
    {
      icon: <FaUserShield />,
      title: "Admin Controls",
      desc: "Role-based access for HR managers, finance, and executives.",
    },
    {
      icon: <FaBell />,
      title: "Smart Notifications",
      desc: "Automatic SMS and email alerts for schedule changes and renewals.",
    },
  ];

  return (
    <div className="staffline-portal-page">

      {/* ===== HERO SECTION ===== */}
      <section
        className="staffline-portal-hero"
        style={{ backgroundImage: `url(${portalHeroImage})` }}
      >
        <div className="staffline-portal-hero-overlay"></div>

        <div className="container staffline-portal-hero-content">
          <span className="staffline-portal-hero-tag">
            <FaRocket /> Coming Soon
          </span>

          <h1 className="staffline-portal-hero-title">
            StaffLine <span>Corporate Portal</span>
          </h1>

          <p className="staffline-portal-hero-subtitle">
            We're building something powerful. Our advanced Corporate Portal is
            currently in development — designed to give companies full control
            over their staff shuttle program.
          </p>

          <div className="staffline-portal-hero-status">
            <div className="staffline-portal-status-badge">
              <FaClock />
              <span>In Advanced Progress</span>
            </div>
            <div className="staffline-portal-progress-bar">
              <div className="staffline-portal-progress-fill"></div>
            </div>
            <span className="staffline-portal-progress-text">
              Development: 75% Complete
            </span>
          </div>

          <div className="staffline-portal-hero-actions">
            <Link to="/contact-us" className="staffline-portal-btn-primary">
              <FaEnvelope /> Contact Us for Info
            </Link>
            <Link to="/subscription" className="staffline-portal-btn-secondary">
              View Subscription <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* ===== INTRO SECTION ===== */}
      <section className="staffline-portal-intro">
        <div className="container">
          <span className="staffline-portal-section-tag">
            <FaRocket /> What's Coming
          </span>
          <h2 className="staffline-portal-section-title">
            A Portal Built for Modern Companies
          </h2>
          <p className="staffline-portal-section-desc">
            The StaffLine Corporate Portal will give HR teams, finance
            departments, and executives a complete toolkit to manage employee
            commuting — all in one beautiful, easy-to-use dashboard. Whether
            you're onboarding new staff or tracking monthly reports, the portal
            will make everything effortless.
          </p>
        </div>
      </section>

      {/* ===== FEATURES GRID ===== */}
      <section className="staffline-portal-features-section">
        <div className="container">
          <div className="staffline-portal-features-grid">
            {portalFeatures.map((feature, index) => (
              <div className="staffline-portal-feature-card" key={index}>
                <div className="staffline-portal-feature-icon">
                  {feature.icon}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CONTACT CTA SECTION ===== */}
      <section className="staffline-portal-contact-section">
        <div className="container">
          <div className="staffline-portal-contact-box">
            <div className="staffline-portal-contact-left">
              <span className="staffline-portal-contact-tag">
                <FaRocket /> Need Info Now?
              </span>
              <h2>
                The Portal Isn't Live Yet — But We Are
              </h2>
              <p>
                While our Corporate Portal is in development, you can reach out
                to us directly for any information, questions, or corporate
                plan inquiries. Our team is ready to help you set up your
                staff's shuttle service today.
              </p>

              <ul className="staffline-portal-contact-list">
                <li>
                  <FaCheckCircle /> Corporate pricing and custom quotes
                </li>
                <li>
                  <FaCheckCircle /> Bulk subscription setup for your company
                </li>
                <li>
                  <FaCheckCircle /> Demo of the upcoming portal features
                </li>
                <li>
                  <FaCheckCircle /> Early access requests
                </li>
              </ul>
            </div>

            <div className="staffline-portal-contact-right">
              <div className="staffline-portal-contact-card">
                <h3>Get in Touch</h3>

                <a
                  href="mailto:stafflinetransportgh@gmail.com"
                  className="staffline-portal-contact-item"
                >
                  <div className="staffline-portal-contact-icon">
                    <FaEnvelope />
                  </div>
                  <div>
                    <span>Email Us</span>
                    <strong>stafflinetransportgh@gmail.com</strong>
                  </div>
                </a>

                <a
                  href="tel:+233531030191"
                  className="staffline-portal-contact-item"
                >
                  <div className="staffline-portal-contact-icon">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <span>Call Us</span>
                    <strong>+233 53 103 0191</strong>
                  </div>
                </a>

                <a
                  href="https://wa.me/233531030191"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="staffline-portal-contact-item"
                >
                  <div className="staffline-portal-contact-icon">
                    <FaWhatsapp />
                  </div>
                  <div>
                    <span>WhatsApp</span>
                    <strong>Chat with us now</strong>
                  </div>
                </a>

                <Link
                  to="/contact-us"
                  className="staffline-portal-contact-btn"
                >
                  <FaEnvelope /> Contact Us <FaArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="staffline-portal-final-cta">
        <div className="container staffline-portal-final-cta-content">
          <FaLock className="staffline-portal-final-icon" />
          <h2>Already a StaffLine Subscriber?</h2>
          <p>
            Individual subscriber logins are coming soon too. In the meantime,
            use WhatsApp or email to manage your subscription.
          </p>
          <div className="staffline-portal-final-actions">
            <Link to="/contact-us" className="staffline-portal-final-btn">
              <FaEnvelope /> Contact Support
            </Link>
            <a
              href="https://wa.me/233531030191"
              target="_blank"
              rel="noopener noreferrer"
              className="staffline-portal-final-btn staffline-portal-final-btn-whatsapp"
            >
              <FaWhatsapp /> WhatsApp Us
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Portal;